module.exports = __webpack_public_path__ + "img/seixas.05283126.webp";